// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Query } from 'react-apollo'
import { isEmpty } from 'lodash'

import {
  Spinner,
  Warning
} from '../'

import { BankAccountOption } from './BankAccountOption'
import { default as BankAccountRequestShowOrCreate } from './BankAccountRequestShowOrCreate'

import { QUERY_IDENTITY_BANKACCOUNTS } from '../../queries'

import { decodeBase64 } from '../../utils'


export const SelectIdentityBankAccount = ({ label, identityId, value, onChange, className }) => (
  <div className={className}>
    <Query query={QUERY_IDENTITY_BANKACCOUNTS} variables={{ uuid: decodeBase64(identityId), status: 'verified' }}>
      {({ loading, error, data }) => {
        const dataFetched = !isEmpty(data)

        const primaryIdentityBankAccount = dataFetched && data.identitybankaccounts.edges.length > 0
          ? data.identitybankaccounts.edges.find(account => account.node.default)
          : null

        const secondaryIdentityBankAccounts = dataFetched && data.identitybankaccounts.edges.length > 0
          ? data.identitybankaccounts.edges.filter(account => account.node.default === false)
          : []

        return (
          <Fragment>
            {dataFetched && primaryIdentityBankAccount === null
              ? <BankAccountRequestShowOrCreate identityId={identityId} />
              : <Fragment>
                  {label &&
                    <label htmlFor='bankaccounts' className='slds-text-color_weak'>
                      {label}
                    </label>
                  }
                  <select
                    id='bankaccounts'
                    value={value}
                    onChange={onChange}
                    className='slds-select'>

                    {loading
                      ? <Spinner size='small' />
                      : error
                        ? <div className='slds-grid'>
                            <Warning>Failed to load options.</Warning>
                          </div>
                        : <Fragment>
                            <option selected={value === null} disabled hidden>  {/*'None' will be shown if creditapplication.bankaccount is null*/}
                              None
                            </option>
                            {primaryIdentityBankAccount &&
                              <optgroup label='Primary account'>
                                <BankAccountOption
                                  id={primaryIdentityBankAccount.node.bankaccount.id}
                                  bankName={primaryIdentityBankAccount.node.bankaccount.bankName}
                                  accountNumber={primaryIdentityBankAccount.node.bankaccount.accountNumber}
                                />
                              </optgroup>
                            }
                            {secondaryIdentityBankAccounts.length > 0 &&
                              <optgroup label='Secondary accounts'>
                                {secondaryIdentityBankAccounts.map(({ node: identityBankAccount }) => (
                                  <BankAccountOption
                                    id={identityBankAccount.bankaccount.id}
                                    bankName={identityBankAccount.bankaccount.bankName}
                                    accountNumber={identityBankAccount.bankaccount.accountNumber}
                                    key={`secondaryBankAccount_${identityBankAccount.bankaccount.id}`}
                                  />
                                ))}
                              </optgroup>
                            }
                          </Fragment>
                    }
                  </select>
                </Fragment>
            }
          </Fragment>
        )
      }}
    </Query>
  </div>
)

SelectIdentityBankAccount.propTypes = {
  label: PropTypes.string,
  identityId: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  className: PropTypes.string
}

SelectIdentityBankAccount.defaultProps = {
  className: ''
}



// WEBPACK FOOTER //
// ./src/components/select-identity-bankaccount/index.js